export const isDesktopOrLaptopQuery = '(min-device-width: 1224px)';
export const isBigScreenQuery = '(min-device-width: 1824px)';
export const isTabletOrMobileQuery = '(max-width: 1224px)';
export const isTabletOrMobileDeviceQuery = '(max-device-width: 1224px)';
export const isPortraitQuery = '(orientation: portrait)';
export const isRetinaQuery = '(min-resolution: 2dppx)';
